import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencyUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/currencyUtilities';
import './FormattedCurrency.scss';

interface DisplayCurrencyProps {
  value: number;
  currency: string;
}

const ignoreSymbolsForCurrency = new Set(['RSD']);

export const FormattedCurrency: React.FC<DisplayCurrencyProps> = ({ value, currency }) => {
  const { i18n } = useTranslation();
  const useSymbol = !ignoreSymbolsForCurrency.has(currency);
  const formatted = currencyUtilities.formatCurrencyWithOrientation(
    value,
    currency,
    i18n.language,
    true,
    useSymbol,
    true,
  );

  return <div className={`currency`}>{<span>{formatted}</span>}</div>;
};
export default FormattedCurrency;
